import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async findByBrandAndApplicationAndParameter(appId, paramId) {
        return await http.get(buildUrlFromLocation(`/brand-applications-has-parameters/${appId}/${paramId}`));
    }
};



// WEBPACK FOOTER //
// ./src/services/brandApplicationHasParameters.js